/* Add styles to pack */
import '../styles/webshop/index.scss';

/* Add images to pack */
require['context']('../images/webshop', true);
require['context']('../images/shared', true);
require['context']('../fonts/volkswagen', true);
require['context']('../fonts/galano', true);

/* Add rails specific libs */
import Rails from 'rails-ujs';
import Turbolinks from 'turbolinks';

Rails.start();
Turbolinks.start();

import 'reflect-metadata';

import * as SharedCore from 'shared/core';
import * as SharedElements from 'shared/elements';
import { WindowBase } from 'shared/models/windowBase';

import * as WebshopCore from 'webshop/core';
import * as WebshopModules from 'webshop/modules';
import * as WebshopElements from 'webshop/elements';

/* Create and export to global scope the App */
export const Webshop = new SharedCore.App({
  /* Providers are singletons used across the app */
  providers: [
    SharedCore.State,
    SharedCore.Display,
    SharedCore.Forms,
    SharedCore.Router,
    SharedCore.TurboLinks,
    SharedCore.Http,
    WebshopCore.Validators,
  ],
  /* Elements are shared, reused across different views */
  elements: [
    SharedElements.AccordionElement,
    SharedElements.ButtonStacking,
    SharedElements.DoubleClickProtectionElement,
    SharedElements.ExpandElement,
    SharedElements.FlashElement,
    SharedElements.FormsElement,
    SharedElements.LayoutElement,
    SharedElements.ModalElement,
    SharedElements.ScreenDetailsElement,
    SharedElements.TabsElement,
    SharedElements.TooltipElement,
    SharedElements.TypeAheadListElement,

    WebshopElements.BasketElement,
    WebshopElements.BreadcrumbsElement,
    WebshopElements.MenuElement,
    WebshopElements.PersonalisationsElement,
  ],
  /* Modules are executed only on particular view based on path */
  routes: [
    {
      path: '',
      exact: true,
      modules: [WebshopModules.RedirectModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['account', 'subscription_edit'],
      modules: [WebshopModules.SubscriptionModule],
    },
    {
      path: 'account',
      modules: [WebshopModules.AccountModule, WebshopModules.ChildrenModule],
    },
    {
      path: 'addresses',
      modules: [WebshopModules.AddressesModule],
    },
    {
      path: 'children',
      exclude: ['edit_measurements', 'update_measurements'],
      modules: [WebshopModules.ChildrenModule],
    },
    {
      path: ['children', 'edit_measurements'],
      modules: [WebshopModules.ChildrenMeasurementsModule],
    },
    {
      path: ['children', 'update_measurements'],
      modules: [WebshopModules.ChildrenMeasurementsModule],
    },
    {
      path: 'faqs',
      modules: [WebshopModules.FaqModule],
    },
    {
      path: ['basket', 'checkout', 'nametags'],
      modules: [WebshopModules.NameTagsModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'fasttrack'],
      modules: [],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'payment'],
      modules: [WebshopModules.PaymentModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'finalize'],
      modules: [WebshopModules.PaymentAuthenticationModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: 'basket/checkout',
      exact: true,
      modules: [WebshopModules.CheckoutModule, WebshopModules.ChangeAddressModule, WebshopModules.ProductModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'forgotten'],
      modules: [WebshopModules.ForgottenModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'shipping'],
      modules: [WebshopModules.ShippingModule, WebshopModules.ChangeAddressModule, WebshopModules.DeliveryOptionsModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'check_tax_reference'],
      modules: [WebshopModules.ShippingModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['basket', 'checkout', 'check_duplication'],
      modules: [],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['smartpay_checkouts', 'finalize'],
      modules: [WebshopModules.PaymentAuthenticationModule, WebshopModules.UnifiedCheckoutModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['invoices', 'payment'],
      modules: [WebshopModules.PaymentModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['invoices', 'finalize_with_card'],
      modules: [WebshopModules.PaymentAuthenticationModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['invoices', 'finalize_with_smartpay'],
      modules: [WebshopModules.PaymentAuthenticationModule, WebshopModules.UnifiedCheckoutModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['invoices'],
      modules: [WebshopModules.InvoiceModule]
    },
    {
      path: ['vouchers'],
      modules: [WebshopModules.VouchersModule]
    },
    {
      path: ['order', 'finalise'],
      modules: [],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: 'orders',
      exclude: ['returns'],
      modules: [WebshopModules.OrdersModule],
    },
    {
      path: ['returns', 'confirm'],
      modules: [WebshopModules.OrdersModule, WebshopModules.OnlineReturnsConfirmModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['returns', 'shipping'],
      modules: [WebshopModules.ChangeAddressModule, WebshopModules.PickUpModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['returns', 'payment'],
      modules: [WebshopModules.PaymentModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: ['returns'],
      modules: [WebshopModules.AmendmentsModule],
      disable: [WebshopElements.BasketElement],
    },
    {
      path: 'curriculum_collections',
      modules: [WebshopModules.ShopModule, WebshopModules.ChangeAddressModule, WebshopModules.ProductModule],
    },
    {
      path: 'spors',
      modules: [WebshopModules.ProductModule, WebshopModules.ProductGalleryModule, WebshopModules.ChangeAddressModule],
    },
    {
      path: 'sub_school_products',
      modules: [WebshopModules.ProductModule, WebshopModules.ProductGalleryModule, WebshopModules.ChangeAddressModule],
    },
    {
      path: 'news',
      modules: [WebshopModules.NewsModule],
    },
    {
      path: 'contact_us',
      modules: [WebshopModules.ContactUsModule],
    },
    {
      path: 'custom_enquiries',
      modules: [WebshopModules.ContactUsModule],
    },
    {
      path: ['gdpr', 'subject_access_request'],
      modules: [WebshopModules.GdprModule],
    },
    {
      path: ['gdpr', 'rte_request'],
      modules: [WebshopModules.GdprModule],
    },
    {
      path: ['repairs', 'confirmation'],
      modules: [WebshopModules.RepairsConfirmModule],
    },
    {
      path: ['repairs', 'new'],
      modules: [WebshopModules.RepairsNewModule]
    },
    {
      path: ['repairs'],
      modules: [WebshopModules.RepairsModule],
    }
  ]
});

// Expose App Outside of Webpack Scope
declare global {
  interface Window extends WindowBase {
    /* Pca Addresses */
    pca: {
      fieldMode: {
        SEARCH: number;
        COUNTRY: number;
        POPULATE: number;
      };
      Address: new (
        fields: Array<{ element: string; field: string; mode: number }>,
        options: { key: string; countries: { codesList: string } }
      ) => {
        listen(event: 'populate', callback: () => void): void;
        listen(event: 'country', callback: (data: { iso2: string }) => void): void;
        setCountry(country: string | undefined): void;
      };
    };
    google: any;
  }
}

window.App = Webshop;

// Must be the last thing to run on the setup
Webshop.run();
